import { Button, Div, ModalPortal, P } from '@vgrubs/components';

export const ApplyAssignmentToBrands = ({
  isOpen,
  setIsOpen,
  handleSubmit,
}) => {
  return (
    <ModalPortal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      overflow="visible"
      zIndex={131}
    >
      <Div $flex $column $alignCenter $gap="24px" $mt="4">
        <P $m="0" $center $maxWidth="300px">
          Do you want to apply this delivery strategy setup to all brands
          connected to this location?
        </P>
      </Div>
      <Div $flex $center $mt="32" $gap="16px">
        <Button $w="100%" $selected onClick={() => handleSubmit(true)}>
          Yes
        </Button>
        <Button $w="100%" $selected $gray onClick={() => handleSubmit(false)}>
          No
        </Button>
      </Div>
    </ModalPortal>
  );
};
